/** Public proof format only. No staff records or privileges belong in the chat app. */
export const STAFF_LOGIN_TTL_MS = 5 * 60 * 1000;
export interface StaffLoginChallenge {
  flow_id: string;
  nonce: string;
  audience: string;
  source_ip: string;
  expires_at: number;
}
export interface StaffLoginProof {
  flow_id: string;
  account_xid: string;
  signature: string;
}

export function validStaffChallenge(value: unknown, audience: string): value is StaffLoginChallenge {
  if (!value || typeof value !== "object") return false;
  const v = value as Record<string, unknown>;
  return typeof v.flow_id === "string" && /^[A-Za-z0-9_-]{43}$/.test(v.flow_id)
    && typeof v.nonce === "string" && /^[A-Za-z0-9_-]{43}$/.test(v.nonce)
    && v.audience === audience
    && typeof v.source_ip === "string" && /^[a-fA-F0-9:.]{2,45}$/.test(v.source_ip)
    && typeof v.expires_at === "number" && Number.isSafeInteger(v.expires_at);
}

export function validStaffProof(value: unknown): value is StaffLoginProof {
  if (!value || typeof value !== "object") return false;
  const v = value as Record<string, unknown>;
  return typeof v.flow_id === "string" && /^[A-Za-z0-9_-]{43}$/.test(v.flow_id)
    && typeof v.account_xid === "string" && /^[A-Za-z0-9_-]{10,80}$/.test(v.account_xid)
    && typeof v.signature === "string" && /^[A-Za-z0-9_-]{86}$/.test(v.signature);
}

/** Domain separated from chat login, key rotation, messages, and device linking. */
export function staffLoginBytes(challenge: StaffLoginChallenge, accountXid: string): Uint8Array {
  return new TextEncoder().encode(JSON.stringify([
    "link.staff-login.v1", challenge.audience, challenge.flow_id, challenge.nonce,
    challenge.source_ip, challenge.expires_at, accountXid,
  ]));
}

export function exactOrigin(value: string, allowLocal: boolean): string {
  const url = new URL(value);
  if (url.origin !== value || url.username || url.password
      || (url.protocol !== "https:" && !(allowLocal && url.protocol === "http:" && ["localhost", "127.0.0.1", "[::1]"].includes(url.hostname)))) {
    throw new Error("A trusted HTTPS origin is required.");
  }
  return url.origin;
}
